import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { backend, } = app;
const { urls, } = backend;

export const LoginService = {
    /**
     * Forgot your password
     * @param {Object} params
     * @param {string} params.email
     * @param {string} params.reCaptchaToken
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @returns 
     */
    forgotPassword: async ({
        email = '',
        reCaptchaToken = '',
        languageId = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'forgotYourPassword - services';
        let response = getResponse({ type: 0 });
        try {
            const forgotPasswordData = {
                email: email,
                method: backend?.methods?.accounts?.forgotPassword,
                reCaptchaToken: reCaptchaToken,
                languageId: languageId,
            };

            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.login}/`,
                data: forgotPasswordData,
                subMethod: currentMethod
            });

            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },
    /**
     * Register new user
     * @param {Object} params
     * @param {string} params.firstName
     * @param {string} params.lastName
     * @param {string} params.phoneNumber
     * @param {string} params.email
     * @param {string} params.password
     * @param {string} params.passwordConfirm
     * @param {string} params.reCaptchaToken
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @returns 
     */
    registerAccount: async ({
        firstName = '',
        lastName = '',
        phoneNumber = '',
        email = '',
        password = '',
        passwordConfirm = '',
        reCaptchaToken = '',
        languageId = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'registerAccount - services';
        let response = getResponse({ type: 0 });
        try {
            const registerAccountData = {
                firstName: firstName,
                lastName: lastName,
                phoneNumber: phoneNumber,
                email: email,
                password: password,
                passwordConfirm: passwordConfirm,
                method: backend?.methods?.accounts?.register,
                reCaptchaToken: reCaptchaToken,
                languageId: languageId,
            };

            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.login}/`,
                data: registerAccountData,
                subMethod: currentMethod
            });

            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },
    /**
     * LogIn
     * @param {Object} params
     * @param {string} params.email
     * @param {string} params.password
     * @param {boolean} params.rememberMe
     * @param {string} params.reCaptchaToken
     * @param {string} params.subMethod
     * @returns 
     */
    login: async ({
        email = '',
        password = '',
        rememberMe = false,
        reCaptchaToken = '',
        languageId = 'en',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'login - services';
        let response = getResponse({ type: 0 });
        try {
            const data = {
                email: email,
                password: password,
                rememberMe: rememberMe,
                reCaptchaToken: reCaptchaToken,
                languageId: languageId
            };

            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.login}/`,
                data: data,
                subMethod: currentMethod
            });

            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },
    /**
     * Get registration status
     * @param {Object} params
     * @param {string} params.email
     * @param {string} params.password
     * @param {string} params.reCaptchaToken
     * @param {string} params.languageId
     * @param {string} params.subMethod
     * @returns 
     */
    getRegisterStatus: async ({
        email = '',
        password = '',
        reCaptchaToken = '',
        languageId = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getRegisterStatus - services';
        let response = getResponse({ type: 0 });
        try {
            const registerStatusData = {
                email: email,
                password: password,
                method: backend?.methods?.accounts?.registerStatus,
                reCaptchaToken: reCaptchaToken,
                languageId: languageId,
            };

            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.login}/`,
                data: registerStatusData,
                subMethod: currentMethod
            });

            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    }
}